import { createReducer, on } from '@ngrx/store';
import {
  getConsultationsWithoutVisitSuccess,
  resetState,
  resetGrowthChart,
  setGrowthChart,
  setGrowthChartNotSavedPastWeights,
} from './pet.actions';
import { initialPetState } from './pet.state';

export const petReducer = createReducer(
  initialPetState,
  on(getConsultationsWithoutVisitSuccess, (state, { consultations }) => ({
    ...state,
    consultationsWithoutVisit: consultations,
  })),
  on(setGrowthChartNotSavedPastWeights, (state, { weight }) => ({
    ...state,
    growthChartData: { ...state.growthChartData, notSavedPastWeights: [...state.growthChartData.notSavedPastWeights, weight] },
  })),
  on(setGrowthChart, (state, { chartImage, chartWeights }) => ({
    ...state,
    growthChartData: { ...state.growthChartData, chartImage, chartWeights },
  })),
  on(resetGrowthChart, (state) => ({ ...state, growthChartData: initialPetState.growthChartData })),
  on(resetState, () => initialPetState),
);
